var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompensation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 61,
    viewBox: "0 0 77 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1855_4311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7558 5.01503L4.93167 22.8391C0.708245 27.0626 0.708245 33.9101 4.93167 38.1335L22.7558 55.9576C26.9792 60.181 33.8267 60.181 38.0501 55.9576L55.8743 38.1335C60.0977 33.9101 60.0977 27.0626 55.8743 22.8392L38.0501 5.01504C33.8267 0.791615 26.9792 0.791612 22.7558 5.01503Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7558 5.01503L4.93167 22.8391C0.708245 27.0626 0.708245 33.9101 4.93167 38.1335L22.7558 55.9576C26.9792 60.181 33.8267 60.181 38.0501 55.9576L55.8743 38.1335C60.0977 33.9101 60.0977 27.0626 55.8743 22.8392L38.0501 5.01504C33.8267 0.791615 26.9792 0.791612 22.7558 5.01503Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5847 23.2223V37.7785C20.5847 39.1812 21.7218 40.3184 23.1245 40.3184H37.6807C39.0834 40.3184 40.2205 39.1812 40.2205 37.7785V23.2223C40.2205 21.8196 39.0834 20.6825 37.6807 20.6825H23.1245C21.7218 20.6825 20.5847 21.8196 20.5847 23.2223Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.937 55.9663C43.17 60.1994 50.0248 60.1994 54.2578 55.9663L72.0639 38.1602C74.1668 36.0573 75.2319 33.299 75.2319 30.5134C75.2319 27.7551 74.1668 24.9695 72.0639 22.8666L54.2578 5.06053C50.0248 0.827481 43.17 0.827481 38.937 5.06053",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1855_4311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.1948,
    height: 60,
    fill: "white",
    transform: "translate(0.402588 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompensation);
export default __webpack_public_path__ + "static/media/compensation.8fba43623b424d4a8671c4a6de341616.svg";
export { ForwardRef as ReactComponent };